<div class="container mainbox">
    <form [formGroup]="mainForm" *ngIf="dataLoaded; else loading">
        <h1 class="form-group title-position" style="margin-top: 20px;" translate>blacklist.title</h1>

        <div id="mainContent" role="tablist" aria-multiselectable="true">
            <div class="card">
                <div class="card-header" id="mainSection">
                    <h5 class="mb-0">
                        <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseMainSection"
                            aria-expanded="true" aria-controls="collapseMainSection" translate>
                            blacklist.mainSection
                        </button>
                    </h5>
                </div>
                <div id="collapseMainSection" class="collapse show" aria-labelledby="mainSection" data-parent="#mainContent">
                    <div class="card-body">
                        <div class="container-fluid row">

                            <div class="col-lg-6 col-md-12">
                                <label style="margin-top: 12px;">
                                    <span translate>blacklist.channel</span> <span class="text-danger">*</span>
                                </label>
                                <div class="d-flex flex-wrap" style="gap: 24px;">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="smsChannelSwitch"
                                            formControlName="smsChannel" (change)="onSmsChannelChange()">
                                        <label class="custom-control-label" for="smsChannelSwitch" translate>blacklist.channel.sms</label>
                                    </div>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="emailChannelSwitch"
                                            formControlName="emailChannel" (change)="onEmailChannelChange()">
                                        <label class="custom-control-label" for="emailChannelSwitch" translate>blacklist.channel.email</label>
                                    </div>
                                </div>
                                <div class="text-danger small mt-1"
                                    *ngIf="showValidations && mainForm.errors?.atLeastOneChannel"
                                    translate>errors.atLeastOneChannel</div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <label style="margin-top: 12px;">
                                    <span translate>blacklist.reason</span> <span class="text-danger">*</span>
                                </label>
                                <select class="custom-select input-custom-size" formControlName="reason"
                                    [ngClass]="{ 'is-invalid': showValidations && f.reason.errors }">
                                    <option [ngValue]="null" disabled translate>placeholder.select</option>
                                    <option value="gdpr-request" translate>blacklist.reason.gdpr</option>
                                    <option value="unsubscribe" translate>blacklist.reason.unsubscribe</option>
                                    <option value="spam-complaint" translate>blacklist.reason.spam</option>
                                    <option value="other" translate>blacklist.reason.other</option>
                                </select>
                                <div class="invalid-feedback" *ngIf="f.reason.errors?.required && showValidations" translate>errors.required</div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <label style="margin-top: 12px;">
                                    <span translate>blacklist.phone</span>
                                    <span class="text-danger" *ngIf="f.smsChannel.value">*</span>
                                </label>
                                <input type="text" class="form-control" formControlName="phone"
                                    placeholder="{{'placeholder.enter' | translate}}"
                                    [ngClass]="{ 'is-invalid': showValidations && f.phone.errors }">
                                <div class="invalid-feedback" *ngIf="f.phone.errors?.required && showValidations" translate>errors.required</div>
                                <div class="invalid-feedback" *ngIf="f.phone.errors?.invalidPhoneNumber && showValidations" translate>errors.phoneInvalid</div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <label style="margin-top: 12px;">
                                    <span translate>blacklist.email</span>
                                    <span class="text-danger" *ngIf="f.emailChannel.value">*</span>
                                </label>
                                <input type="email" class="form-control" formControlName="email"
                                    placeholder="{{'placeholder.enter' | translate}}"
                                    [ngClass]="{ 'is-invalid': showValidations && f.email.errors }">
                                <div class="invalid-feedback" *ngIf="f.email.errors?.required && showValidations" translate>errors.required</div>
                                <div class="invalid-feedback" *ngIf="f.email.errors?.email && showValidations" translate>errors.mailInvalid</div>
                            </div>

                            <div class="col-12">
                                <label style="margin-top: 12px;" translate>blacklist.note</label>
                                <textarea class="form-control" rows="3" formControlName="note"
                                    placeholder="{{'placeholder.enter' | translate}}"></textarea>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="d-flex justify-content-end" style="gap: 10px;" *ngIf="dataLoaded">
        <button class="btn btn-danger" type="button" *ngIf="isEdit"
            [disabled]="disableActionBtn" style="margin-top: 10px;" (click)="delete()">
            <i class="fa fa-trash"></i>&nbsp;<span translate>button.delete</span>
        </button>
        <button class="btn btn-primary w-20" type="button"
            [disabled]="disableActionBtn" style="margin-top: 10px;" (click)="save()" translate>button.save</button>
    </div>

    <ng-template #loading>
        <div *ngIf="errorMessage$ | async as errorMessage; else spinner">
            <div class="alert alert-danger">
                {{errorMessage}}
            </div>
            <div class="d-flex justify-content-center">
                <i class="fa fa-refresh" (click)="reload()"></i>
            </div>
        </div>
        <ng-template #spinner>
            <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </ng-template>
    </ng-template>
</div>
